var sliderContent = function (container, text, image) {
  var $container = $(container);

  var imageNav = image.attr('class');

  // Text slider
  var $text = $(text).flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    asNavFor: `.${imageNav}`,
    prevNextButtons: false,
    draggable: false,
  });

  // Image slider
  var $gallery = $(image).flickity({
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    wrapAround: true,
    pageDots: false,
    lazyLoad: true,
    imagesLoaded: true,
  });

  // Custom nav
  var flkty = $gallery.data('flickity');

  // Bind Previous
  $container.find('.previous').on('click', function () {
    $gallery.flickity('previous');
  });

  // Bind Next
  $container.find('.next').on('click', function () {
    $gallery.flickity('next');
  });

  var $currentSlideNumber = $container.find('.current-slider');

  $gallery.on('cellSelect', function () {
    // var slideCount = $(image).find('.is-selected').attr('data-count');
    var slideCount = $gallery.data('flickity').selectedIndex + 1;

    slideCount = slideCount < 10 ? `0${slideCount}` : slideCount;
    $currentSlideNumber.html(slideCount);
  });
};
window.sliderContent = sliderContent;
